import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class LandingpageComponent {
 
  constructor(public util:UtilService, public router: Router) {
    
  }
 
 partners: Image[] = [
    {src: 'assets/images/square_logo_2x.png', alt: 'Square logo'},
    {src: 'assets/images/livechat_logo_2x.png', alt: 'Livechat logo'},
    {src: 'assets/images/mapbox_logo_2x.png', alt: 'Mapbox logo'},
    {src: 'assets/images/metamask_logo_2x.png', alt: 'Metamask logo'},
    {src: 'assets/images/people_ai_logo_2x.png', alt: 'People AI logo'},
    {src: 'assets/images/sketch_logo_2x.png', alt: 'Sketch logo'},
  ]

  deliverySteps: DeliveryStep[] = [
    { iconAlt: 'login', iconSrc: 'assets/icons/login.svg', text: "Sign Up or Join Instantly"},
    { iconAlt: 'login', iconSrc: 'assets/icons/link.svg', text: "Generate & Share a Link"},
    { iconAlt: 'login', iconSrc: 'assets/icons/add-square.svg', text: "Join with One Click"},
    { iconAlt: 'login', iconSrc: 'assets/icons/user-tag.svg', text: "Engage with Advanced Features"},
  ]

  services: Service[] = [
    {iconAlt: 'file', iconSrc: '/assets/icons/video-time.svg', text: "HD Video Calls", description: "Enjoy uninterrupted, high-quality video calls with minimal lag."},
    {iconAlt: 'file', iconSrc: '/assets/icons/file.svg', text: "Instant Meeting Links", description: "No downloads or sign-ups required—just share a link and start talking."},
    {iconAlt: 'file', iconSrc: '/assets/icons/shield.svg', text: "Secure & Private", description: "End-to-end encryption protects your conversations."},
    {iconAlt: 'file', iconSrc: '/assets/icons/share.svg', text: "Screen Sharing & Collaboration", description: "Share your screen, chat in real time, and enhance productivity."},
    {iconAlt: 'file', iconSrc: '/assets/icons/devices.svg', text: "Multi-Device Compatibility", description: "Seamlessly switch between desktop, tablet, and mobile."},
  ]

  industries: string[] = [
    "Fintech", "Gaming", "Trading", "Crypto", "Edutech", "Medtech"
  ];

  reviews: Review[] = [
    {
      name: "Roxanne Mustafa",
      bio: "Design Team Lead at VMWare",
      review: '“When the pandemic hit, those of us who thrive on in-person collaboration were worried that our creativity and productivity would suffer. Miro was the perfect tool to help us with collaboration, whiteboarding, and retrospectives while remote.”',
      profileSrc: '/assets/images/review_pfp.png'
    },
    {
      name: "Roxanne Mustafa",
      bio: "Design Team Lead at VMWare",
      review: '“When the pandemic hit, those of us who thrive on in-person collaboration were worried that our creativity and productivity would suffer. Miro was the perfect tool to help us with collaboration, whiteboarding, and retrospectives while remote.”',
      profileSrc: '/assets/images/review_pfp.png'
    },
    {
      name: "Roxanne Mustafa",
      bio: "Design Team Lead at VMWare",
      review: '“When the pandemic hit, those of us who thrive on in-person collaboration were worried that our creativity and productivity would suffer. Miro was the perfect tool to help us with collaboration, whiteboarding, and retrospectives while remote.”',
      profileSrc: '/assets/images/review_pfp.png'
    },
  ]

  footerIcons: Image[] = [
    {src: '/assets/icons/instagram.svg', alt: "Instagram"},
    {src: '/assets/icons/facebook.svg', alt: "Facebook"},
    {src: '/assets/icons/twitch.svg', alt: "Twitch"},
    {src: '/assets/icons/xrp.svg', alt: "XRP"},
  ]

  contactForm = new FormGroup({
    form_name: new FormControl('', [Validators.required]),
    form_practice: new FormControl(''),
    form_email: new FormControl('', [Validators.required]),
    form_message: new FormControl('', [Validators.required]),
    form_subscribe: new FormControl(false)
  })

  identify(index: number, partner: Image) {
    partner.src
  }

  slideFromRight: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.transform = intersecting ? "translateX(0)" : "translateX(50%)";
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0.3"
    })
  }

  slideFromLeft: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.transform = intersecting ? "translateX(0)" : "translateX(-80%)";
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0.3"
    })
  }

  slideFromBottom: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.transform = intersecting ? "translateY(0) translateX(-50%)" : "translateY(200px) translateX(-50%)";
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
    })
  }

  slideFromTop: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.transform = intersecting ? "translateY(0) translateX(-50%)" : "translateY(-200px) translateX(-50%)";
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
    })
  }

  aboutText: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
      if (intersecting) {
        (entry.target as HTMLElement).classList.add('stagger_children');
      } else {
        (entry.target as HTMLElement).classList.remove('stagger_children');
      }
    })
  }

  communicationSteps: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
      if (intersecting) {
        (entry.target as HTMLElement).classList.add('stagger_children_communication');
      } else {
        (entry.target as HTMLElement).classList.remove('stagger_children_communication');
      }
    })
  }

  servicesList: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
      if (intersecting) {
        (entry.target as HTMLElement).classList.add('stagger_children_services__list');
      } else {
        (entry.target as HTMLElement).classList.remove('stagger_children_services__list');
      }
    })
  }

  industriesList: IntersectionObserverCallback = (entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      (entry.target as HTMLElement).style.opacity = intersecting ? "1" : "0"
      if (intersecting) {
        (entry.target as HTMLElement).classList.add('stagger_children_industries__list');
      } else {
        (entry.target as HTMLElement).classList.remove('stagger_children_industries__list');
      }
    })
  }

  ngOnInit(): void {
    const observer = new IntersectionObserver(this.slideFromRight)
    const observerLeft = new IntersectionObserver(this.slideFromLeft)
    const observerTop = new IntersectionObserver(this.slideFromTop, {threshold: 0.1})
    const observerAboutText = new IntersectionObserver(this.aboutText, {threshold: 0.3})
    const observerCommunicationText = new IntersectionObserver(this.aboutText, {threshold: 0})
    const observerCommunicationSteps = new IntersectionObserver(this.communicationSteps, {threshold: 0.3})
    const observerServicesList = new IntersectionObserver(this.servicesList)
    const observerIndustriesList = new IntersectionObserver(this.industriesList, {threshold: 0.3})
    observer.observe(document.getElementById("hero__img")!)
    observerTop.observe(document.getElementById("hero__phone")!)
    observerLeft.observe(document.getElementById("about__img")!)
    observerAboutText.observe(document.getElementById("about__text")!)
    observerCommunicationText.observe(document.getElementById("communication")!)
    observerCommunicationSteps.observe(document.getElementById("communication__steps")!)
    observerServicesList.observe(document.getElementById("services__list")!)
    observerIndustriesList.observe(document.getElementById("industries__list")!)


  }

  links: Link[] = [
    {text: "About", href: "/landingpage#about"},
    {text: "Services", href: "/landingpage#services"},
    // {text: "Blog", href: "/blog"},
    //{text: "Testimonial", href: "/landingpage#reviews"},
    // {text: "FAQ", href: "/faq"},
  ]

  submitForm() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return
    }

    window.open(`mailto:hello@alphaonetech.io?body=${this.contactForm.value.form_message}`, '_blank')
  }
}


interface Link {
  text: string, href: string
}


interface Image {
  src: string,
  alt: string
}

interface DeliveryStep {
  text: string,
  iconSrc: string,
  iconAlt: string
}

type Service = DeliveryStep & {
  description: string
}

type Review = {
  name: string,
  bio: string,
  review: string,
  profileSrc: string
}

type FormField = {
  label: string,
  placeHolder: string,
  type: string
}
